
import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

export const useBookingAuth = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userProfile, setUserProfile] = useState<any>(null);
  const [accessToken, setAccessToken] = useState<string | null>(null);
  
  useEffect(() => {
    const checkAuth = async () => {
      // Get the current session and store token
      const { data: { session } } = await supabase.auth.getSession();
      setIsAuthenticated(!!session);
      
      if (session) {
        // Store the access token for API calls
        setAccessToken(session.access_token);
        
        // Fetch profile data
        const { data: profile } = await supabase
          .from('profiles')
          .select('*')
          .eq('id', session.user.id)
          .single();
          
        setUserProfile(profile);
      } else {
        setAccessToken(null);
        setUserProfile(null);
      }
    };
    
    // Check auth initially
    checkAuth();
    
    // Listen for auth changes
    const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
      console.log("Auth state changed in useBookingAuth:", event);
      setIsAuthenticated(!!session);
      
      if (session) {
        // Update the access token when session changes
        setAccessToken(session.access_token);
        
        // Fetch the user profile when session changes
        supabase
          .from('profiles')
          .select('*')
          .eq('id', session.user.id)
          .single()
          .then(({ data }) => {
            setUserProfile(data);
          });
      } else {
        setUserProfile(null);
        setAccessToken(null);
      }
    });
    
    // Cleanup subscription
    return () => {
      subscription.unsubscribe();
    };
  }, []);

  return { isAuthenticated, userProfile, accessToken };
};
